/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasRoofTableViewProps /*, ILobasRoofTableRefineMenuViewProps */ } from './lobas-roof-table';
//import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

const LobasRoofTableView: React.FC<ILobasRoofTableViewProps> = props => {
    const {
        RoofList,
        roofListTable,
        moduleContainer,
        heading,
        //refineMenu,
        RefineAndModuleSectionContainer,
        /*choiceSummary*/ pagination,
        productSegmentRefiners,
        productCategoryRefiners
    } = props;

    return (
        <Module {...RoofList}>
            {productSegmentRefiners}
            {productCategoryRefiners}
            {/*refineMenu && renderRefiner(refineMenu)*/}
            {heading}
            {/* <Node className='ms-refiner-heading'>
                <div className='ms-search-result-wrapper-title-choice-summary'>{choiceSummary}</div>
            </Node> */}
            <Node {...RefineAndModuleSectionContainer}>
                <Node {...moduleContainer}>{roofListTable}</Node>
                {pagination}
            </Node>
        </Module>
    );
};

/*const renderRefiner = (props: ILobasRoofTableRefineMenuViewProps): JSX.Element | null => {
    const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
    if (refiners) {
        return (
            <Node {...RefinerSectionContainer}>
                <Node {...RefineMenuContainer}>
                    {refiners.map((submenu, index) => (
                        <React.Fragment key={index}>{submenu}</React.Fragment>
                    ))}
                </Node>
            </Node>
        );
    }
    return null;
};*/

export default LobasRoofTableView;
